import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

interface FullEngineDownloadDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onEntered?: () => void;
  instantTransition?: boolean;
}

export const FullEngineDownloadDialog = ({
  open,
  onClose,
  onConfirm,
  onEntered,
  instantTransition = false,
}: FullEngineDownloadDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    transitionDuration={instantTransition ? 0 : undefined}
    TransitionProps={{ onEntered }}
  >
    <DialogTitle>NIKOLA IS BRINGING THE BIG BRAIN</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        Deep analysis needs a 108 MB engine and more device memory. Your browser normally caches it, but may download it
        again after storage is cleared. Completed games save one by one.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Not now</Button>
      <Button variant="contained" onClick={onConfirm}>
        Download and analyze
      </Button>
    </DialogActions>
  </Dialog>
);
